import React, { useState } from 'react';
import { Check, MessageSquare, Shield } from 'lucide-react';

const SmsOptIn = () => {
  const [formData, setFormData] = useState({
    phone: '',
    firstName: '',
    lastName: '',
    consent: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.consent) {
      setError('Please check the consent box to continue');
      return;
    }

    if (!formData.phone || formData.phone.length < 10) {
      setError('Please enter a valid phone number');
      return;
    }

    // In production, this would save to your backend
    // For now, just show success message
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '40px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            maxWidth: '600px',
            background: 'white',
            borderRadius: '20px',
            padding: '60px 40px',
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}
        >
          <div
            style={{
              width: '80px',
              height: '80px',
              background: '#10b981',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 30px'
            }}
          >
            <Check size={40} color="white" />
          </div>
          <h1 style={{ fontSize: '32px', marginBottom: '16px', color: '#1f2937' }}>You're All Set! 🎉</h1>
          <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '30px' }}>
            Thank you for subscribing to SMS updates from Vincentrix. You'll start receiving vehicle offers and
            updates soon.
          </p>
          <p style={{ fontSize: '14px', color: '#9ca3af' }}>
            Reply STOP to any message to unsubscribe at any time.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '40px 20px'
      }}
    >
      <div
        style={{
          maxWidth: '600px',
          margin: '0 auto',
          background: 'white',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div
            style={{
              width: '60px',
              height: '60px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}
          >
            <MessageSquare size={30} color="white" />
          </div>
          <h1 style={{ fontSize: '32px', marginBottom: '12px', color: '#1f2937' }}>Get Exclusive Vehicle Offers via SMS</h1>
          <p style={{ fontSize: '16px', color: '#6b7280' }}>
            Be the first to know about great trade-in offers and vehicle deals at Vincentrix
          </p>
        </div>

        {/* Benefits */}
        <div style={{ background: '#f9fafb', borderRadius: '12px', padding: '24px', marginBottom: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
            <Check size={20} color="#10b981" style={{ marginTop: '2px', flexShrink: 0 }} />
            <span style={{ color: '#374151', fontSize: '15px' }}>
              Instant notifications about vehicle offers matching your preferences
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '16px' }}>
            <Check size={20} color="#10b981" style={{ marginTop: '2px', flexShrink: 0 }} />
            <span style={{ color: '#374151', fontSize: '15px' }}>Exclusive trade-in valuations sent directly to your phone</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
            <Check size={20} color="#10b981" style={{ marginTop: '2px', flexShrink: 0 }} />
            <span style={{ color: '#374151', fontSize: '15px' }}>Easy to unsubscribe anytime by replying STOP</span>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>
              First Name
            </label>
            <input
              type="text"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              required
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border 0.2s'
              }}
              onFocus={(e) => (e.target.style.borderColor = '#667eea')}
              onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>
              Last Name
            </label>
            <input
              type="text"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              required
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border 0.2s'
              }}
              onFocus={(e) => (e.target.style.borderColor = '#667eea')}
              onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>
              Mobile Phone Number
            </label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value.replace(/\D/g, '') })}
              placeholder="(555) 123-4567"
              required
              maxLength="10"
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border 0.2s'
              }}
              onFocus={(e) => (e.target.style.borderColor = '#667eea')}
              onBlur={(e) => (e.target.style.borderColor = '#e5e7eb')}
            />
            <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>Standard message and data rates may apply</p>
          </div>

          {/* Consent Checkbox - CRITICAL FOR TWILIO */}
          <div
            style={{
              marginBottom: '24px',
              background: '#fef3c7',
              border: '2px solid #fbbf24',
              borderRadius: '12px',
              padding: '20px'
            }}
          >
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={formData.consent}
                onChange={(e) => setFormData({ ...formData, consent: e.target.checked })}
                required
                style={{ marginTop: '4px', width: '20px', height: '20px', cursor: 'pointer', accentColor: '#667eea' }}
              />
              <span style={{ fontSize: '14px', color: '#78350f', lineHeight: '1.6' }}>
                <strong>I agree to receive automated promotional and transactional text messages</strong> from Vincentrix
                at the phone number provided above. I understand that consent is not a condition of purchase and
                that I can opt out at any time by replying STOP. Message frequency varies. Message and data rates may
                apply. View our <a href="/privacy-policy" style={{ color: '#667eea', textDecoration: 'underline' }}>Privacy Policy</a> and{' '}
                <a href="/terms" style={{ color: '#667eea', textDecoration: 'underline' }}>Terms of Service</a>.
              </span>
            </label>
          </div>

          {error && (
            <div
              style={{
                background: '#fee2e2',
                border: '1px solid #ef4444',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '20px'
              }}
            >
              <p style={{ color: '#991b1b', fontSize: '14px', margin: 0 }}>{error}</p>
            </div>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '16px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '18px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.5)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
            }}
          >
            Subscribe to SMS Updates
          </button>
        </form>

        {/* Privacy Notice */}
        <div
          style={{
            marginTop: '30px',
            padding: '20px',
            background: '#f3f4f6',
            borderRadius: '12px',
            display: 'flex',
            gap: '12px'
          }}
        >
          <Shield size={24} color="#667eea" style={{ flexShrink: 0 }} />
          <div>
            <p style={{ fontSize: '13px', color: '#4b5563', lineHeight: '1.6', margin: 0 }}>
              <strong>Your Privacy Matters:</strong> We will never sell your information. You can unsubscribe at any time by
              texting STOP. For help, text HELP or call us at (555) 123-4567.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmsOptIn;

